import { render, staticRenderFns } from "./BrandTile.vue?vue&type=template&id=536c56a8&"
import script from "./BrandTile.vue?vue&type=script&lang=js&"
export * from "./BrandTile.vue?vue&type=script&lang=js&"
import style0 from "./BrandTile.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./BrandTile.vue?vue&type=custom&index=0&blockType=Custom&Blocks=true"
if (typeof block0 === 'function') block0(component)

export default component.exports